<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userCat">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#addCatForm"
                         aria-controls="addCatForm">
                        {{ $t('label.add_category') }}
                    </div>
                </div>
                <div id="addCatForm" class="collapse" aria-labelledby="addCatForm" data-parent="#userCat">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col lg="6" xs="12" md="12">
                                        <kt-form-group>
                                            <kt-form-label for="cat_name">
                                                {{ $t('label.cat_name') }}
                                            </kt-form-label>
                                            <kt-form-control ref="cat_name"
                                                             dir="rtl"
                                                             name="cat_name"
                                                             id="cat_name"
                                                             v-model="query.title"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-for="priority in 3" :key="priority" lg="6" md="6" sm="12">
                                        <kt-form-group>
                                            <kt-form-label for="dedicated_shop_id_first_priority">
                                                {{ $t('label.gateway') + ' (' + $t('transaction_routing.priority.'+priority) + ')' }}
                                            </kt-form-label>
                                            <select
                                                :id="'dedicated_shop_id_'+priority-1"
                                                class="form-control kt-selectpicker"
                                                v-model="query.dedicated_ids[(priority-1)]"
                                            >
                                                <option value=""></option>
                                                <option
                                                    v-bind:key="index"
                                                    v-for="(category, index) in gateways"
                                                    :value="category.id"
                                                >
                                                    {{ category.farsi_name }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="12">
                                        <kt-button type="submit"
                                                   id="submit_btn"
                                                   variant="success"
                                                   class="btn btn-wide">
                                            {{ $t('btn.submit') }}
                                        </kt-button>
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";
import {KTApp} from "@/plugins/core/app";
import {userService} from "@/common/api.service";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            query: {
                dedicated_ids: []
            },
        }
    },
    methods: {
        afterDispatch() {
            setTimeout(function () {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 2000)
        },

    },
    computed: {
        ...mapGetters('dedicated', [
            'status', 'gateways'
        ])
    },
    mounted() {
        this.$store.dispatch('dedicated/fetchForSelect').finally(() => {
            this.afterDispatch()
        })
    },
}
</script>